/* @flow weak */
import SettingsStore from 'stores/SettingsStore';

export function getCount(text) {
  const charactersSetting = SettingsStore.getSetting('messages', 'characters');
  const urlRegexp = charactersSetting ? new RegExp(charactersSetting.urlregexp, 'g') : null;

  let numberOfUrlsInMessage = 0;
  const textSansUrlsLength = text.replace(urlRegexp, () => {
    numberOfUrlsInMessage++;
    return '';
  }).length;

  const urlWeight = charactersSetting ? charactersSetting.urlweight : 0;
  const urlsLength = urlWeight * numberOfUrlsInMessage;

  return textSansUrlsLength + urlsLength;
}

export function getRemainingCharacters(limit, limitWithFiles, length = 0, hasFiles = false) {
  return (hasFiles ? limitWithFiles : limit) - length;
}

export function getRemainingCharactersForText(limit, limitWithFiles, text, hasFiles = false) {
  return getRemainingCharacters(limit, limitWithFiles, getCount(text), hasFiles);
}

// require() compatibility and to support module spying
export default {
  getCount,
  getRemainingCharacters,
  getRemainingCharactersForText,
};
